import { AtlasContext, AtlasProviderValue } from '../../hoc/atlas-provider/context'
import { useContext } from 'react'

export function useAtlas(): AtlasProviderValue | undefined {
  return useContext(AtlasContext)
}
